import { object, string } from 'yup';

export const preLoginSchema = object().shape({
    user: string().required('field_validations.required'),
});
